const defaultPieChartColors = [
    '#215DB0',
    '#cee4f1',
    '#5ea8d2',
    '#0075C9',
    '#445767',
    '#d5dade',
    '#94A7b2',
    '#5c7080',
]

export const clientThemeUDMS = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#215DB0',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#0075C9',
        userIcon: '#FF3B29',
        brandLogo: {
            maxWidth: '150px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#a1a1aa',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#121315',
        darkBackgroundColor: '#27272a',
        sideMenuActive: {
            backgroundColor: '#215DB0',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#215DB0',
        stroke: '#215DB0',
        lineCharts: {
            stroke: '#215DB0',
            fill: '#215DB0',
        },
        areaCharts: {
            gradient: {
                start: '#215DB0',
                stop: '#215DB0',
            },
            stroke: '#215DB0',
            fill: '#215DB0',
            chargebacksByPostDateChart: {
                stroke: '#215DB0',
                fill: '#215DB0',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#cee4f1',
                    fill: '#cee4f120',
                },
                {
                    stroke: '#215DB0',
                    fill: '#215DB020',
                },
                {
                    stroke: '#5ea8d2',
                    fill: '#5ea8d220',
                },
                {
                    stroke: '#0075C9',
                    fill: '#0075C920',
                },
                {
                    stroke: '#445767',
                    fill: '#44576720',
                },
                {
                    stroke: '#d5dade',
                    fill: '#d5dade20',
                },
            ],
        },
        barCharts: {
            fill: '#0075C9',
            lowestBar: '#d5dade',
            byPlatformBarChart: { fill: '#0075C9' },
            byBinBarChart: { fill: '#0075C9' },
            ertsByRevenueChart: {
                bar1Fill: '#0075C9',
                bar2Fill: '#d5dade',
            },
            averageTimetoFileDispute: { fill: '#215DB0' },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#d5dade',
                lineColor: '#0075C9',
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#cee4f1',
                mid: '#94A7b2',
                high: '#215DB0',
            },
        },
        pieCharts: {
            defaultPieChart: defaultPieChartColors,
            dashboardPieChart: defaultPieChartColors,
            byReasonCodePieChart: defaultPieChartColors,
            byReasonCodeDistributionPieChart: defaultPieChartColors,
            byCardTypePieChart: defaultPieChartColors,
            byLocationTypePieChart: defaultPieChartColors,
            byPlatformPerCardTypePieChart: defaultPieChartColors,
            byStatusPieChart: defaultPieChartColors,
            byWinLossPieChart: defaultPieChartColors,
        },
        radialBarCharts: {
            fill: '#215DB0',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#215DB0',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#215DB0',

            '&:hover': {
                backgroundColor: '#215DB0',
            },
        },
        submittingColor: '#0075C9',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '8px 7px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    select: {
        hover: {
            color: 'inherit',
            backgroundColor: '#F4F4F4',
        },
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#27272a',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 500,
                padding: '4px 10px',
                fontSize: '13px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                borderRadius: '4px',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                borderRadius: '4px',
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#215DB0',
    primaryLight: '#4D7DBF',
    primary: '#215DB0',
    primaryDark: '#17417B',
    secondaryLight: '#3390D3',
    secondary: '#0075C9',
    secondaryDark: '#00518C',
    hyperlink: '#00aeef',
    textField: '#215DB0',
    switch: '#215DB0',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '12px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '12px',
        },
        body1: {
            fontSize: '13px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '13px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '13px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '13px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '13px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(9, 167, 209, .4)',
    },
}
